<div cdkOverlayOrigin #origin="cdkOverlayOrigin">
  <mat-form-field
    appearance="outline"
    class="multi-select-all-none w-full"
    [class.is-overlay-open]="isOverlayOpen"
    floatLabel="always"
    (click)="openOverlay()"
  >
      <mat-label>{{ label || 'Select options' }}</mat-label>

      <ng-container *ngIf="showChipsList; else nonChipsField">
          <fa-icon
              *ngIf="showSearchInput && isOverlayOpen"
              matPrefix
              class="si-icon trigger-search-icon"
              [icon]="['fal', 'magnifying-glass']"
          ></fa-icon>

          <mat-chip-grid tabIndex="-1" #chipGrid class="multi-selector-chip-grid">
              <mat-chip-row
                  tabIndex="-1"
                  class="max-w-full"
                  *ngFor="let option of selectedItems"
                  (removed)="removeChip(option)"
              >
                  <ng-container *ngIf="(option | getBindLabel: items : bindValue : bindLabel) as chipLabel; else loading">
                      <div class="multi-selector-chip-content">
                          <span class="si-ui-chip__label multi-selector-chip-label" [matTooltip]="chipLabel">{{ chipLabel }}</span>
                          <button tabIndex="-1" matChipRemove>
                              <fa-icon class="si-icon" [icon]="['fal', 'circle-xmark']"></fa-icon>
                          </button>
                      </div>
                  </ng-container>
                  <ng-template #loading>
                      <mat-progress-spinner matSuffix [mode]="'indeterminate'" [diameter]="16"></mat-progress-spinner>
                  </ng-template>
              </mat-chip-row>

              <input
                  *ngIf="showSearchInput"
                  #filterInput
                  matInput
                  class="multi-selector-chip-input"
                  type="text"
                  [placeholder]="isOverlayOpen
                      ? ((filteredItems$ | async)?.length === 0 ? 'Type here to create a tag' : 'Type here to search')
                      : ((selectedItems?.length || 0) === 0 ? (placeholder || 'Select options') : '')"
                  [formControl]="filterControl"
                  [matChipInputFor]="chipGrid"
                  [readonly]="!isOverlayOpen"
                  (keydown)="onFilterInputKeydown($event)"
              />
          </mat-chip-grid>
      </ng-container>

      <ng-template #nonChipsField>
          <ng-container *ngIf="showSearchInput && isOverlayOpen; else selectedValueTrigger">
              <fa-icon matPrefix class="si-icon trigger-search-icon" [icon]="['fal', 'magnifying-glass']"></fa-icon>
              <input
                  #filterInput
                  matInput
                  class="multi-selector-search-input"
                  type="text"
                  [placeholder]="(filteredItems$ | async)?.length === 0 ? 'Type here to create a tag' : 'Type here to search'"
                  [formControl]="filterControl"
                  (click)="$event.stopPropagation()"
                  (keydown)="onFilterInputKeydown($event)"
              />
          </ng-container>

          <ng-template #selectedValueTrigger>
              <input
                  matInput
                  class="multi-selector-hidden-control"
                  type="text"
                  tabindex="-1"
                  aria-hidden="true"
                  [value]="(isOverlayOpen || (selectedItems?.length || 0) > 0) ? ' ' : ''"
              />

              <ng-container *ngIf="(selectedItems?.length || 0) > 0; else placeholderTpl">
                  <ng-container *ngIf="(selectedItems | selectAllCheckboxState : items) !== 'checked'; else allSelected">
                      <span class="multi-selector-selected-value">
                          <span
                              class="multi-selector-selected-label"
                              matTooltip="{{ selectedItems?.[0] | getBindLabel : items : bindValue : bindLabel }}"
                              matTooltipPosition="above"
                          >
                              {{ selectedItems?.[0] | getBindLabel : items : bindValue : bindLabel }}
                          </span>
                          <span class="multi-selector-selected-count" *ngIf="(selectedItems?.length || 0) > 1">
                              (+{{ (selectedItems?.length || 0) - 1 }} {{ selectedItems?.length === 2 ? 'other' : 'others' }})
                          </span>
                      </span>
                  </ng-container>
                  <ng-template #allSelected>All Selected</ng-template>
              </ng-container>
              <ng-template #placeholderTpl>
                  <span class="multi-selector-placeholder">{{ placeholder || 'Select options' }}</span>
              </ng-template>
          </ng-template>
      </ng-template>

      <div matSuffix class="flex items-center gap-2">
          <mat-progress-spinner *ngIf="isLoading" [mode]="'indeterminate'" [diameter]="16"></mat-progress-spinner>
          <fa-icon
              aria-hidden="true"
              class="si-icon si-select-arrow"
              [class.si-select-arrow--open]="isOverlayOpen"
              [icon]="['fal', 'chevron-down']"
              (click)="onChevronClick($event)"
          ></fa-icon>
      </div>
  </mat-form-field>
</div>

<ng-template
  cdk-connected-overlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="isOverlayOpen"
  [cdkConnectedOverlayMinWidth]="origin?.elementRef?.nativeElement?.offsetWidth ?? 0"
  [cdkConnectedOverlayHasBackdrop]="!showChipsList"
  [cdkConnectedOverlayBackdropClass]="!showChipsList ? 'bg-transparent' : ''"
  [cdkConnectedOverlayOffsetY]="overlayOffsetY"
  (backdropClick)="closeOverlay()"
  (overlayOutsideClick)="onOverlayOutsideClick($event)"
  (detach)="closeOverlay()"
>
  <div
      class="overlay-panel custom-multi-select-panel"
      [style.width.px]="origin?.elementRef?.nativeElement?.offsetWidth ?? 0"
      [@.disabled]="true"
  >
      <ng-container *ngIf="filteredItems$ | async as filteredItems">
          <div
              class="mat-mdc-option mdc-list-item hide-checkbox"
              *ngIf="preOptionTemplate && filteredItems?.length === 0 && inputValue !== ''"
              (click)="onNoDataClick($event)"
          >
              <ng-container *ngTemplateOutlet="preOptionTemplate; context: { inputValue: inputValue }"></ng-container>
          </div>

          <div class="scrollable-options mt-0">
              <div class="mat-mdc-option mdc-list-item hide-checkbox mx-4" *ngIf="preOptionEmptyTemplate" (click)="onNoDataClick($event)">
                  <ng-container *ngTemplateOutlet="preOptionEmptyTemplate"></ng-container>
              </div>

              <div
                  class="mat-mdc-option mdc-list-item mat-mdc-option-multiple"
                  *ngIf="filteredItems?.length !== 0"
                  (click)="toggleSelectAll(filteredItems); $event.stopPropagation()"
              >
                  <mat-pseudo-checkbox [state]="selectedItems | selectAllCheckboxState : filteredItems"></mat-pseudo-checkbox>
                  <span class="mdc-list-item__primary-text">
                      {{ filteredItems.length === selectedItems.length ? 'Deselect All' : 'Select All' }}
                  </span>
              </div>

              <div
                  class="mat-mdc-option mdc-list-item mat-mdc-option-multiple"
                  *ngFor="let option of filteredItems"
                  (click)="toggleItemSelection(option); $event.stopPropagation()"
              >
                  <mat-pseudo-checkbox [state]="option | multiSelectorOptionState : selectedItems : bindValue"></mat-pseudo-checkbox>
                  <ng-container *ngIf="optionTemplate; else defaultOption">
                      <span class="mdc-list-item__primary-text">
                          <ng-container *ngTemplateOutlet="optionTemplate; context: { $implicit: option }"></ng-container>
                      </span>
                  </ng-container>
                  <ng-template #defaultOption>
                      <span
                          class="mdc-list-item__primary-text truncate"
                          [tooltipIfTruncated]="listElementTooltipIfTruncated ? (bindLabel ? option[bindLabel] : option) : ''"
                      >
                          {{ bindLabel ? option[bindLabel] : option }}
                      </span>
                  </ng-template>
              </div>
          </div>
      </ng-container>
  </div>
</ng-template>
